module.exports = __webpack_public_path__ + "src/img/artist/work06_1.jpg?1f7156bf6c99a15b8ed985ff80b91954";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work06_1.jpg
// module id = 23
// module chunks = 0